<template>
  <b-container fluid>
    <b-row  id="header-container-short" class="justify-content-center">
      <b-col md="10">
        <b-row align-h="between">
          <b-col md="6">
            <a href="/">
              <img alt="gravity logo" src="../../assets/logo-mom-450.png" />
            </a>
          </b-col>
          <b-col md="6" class="started-button">
            <a
              href="/masters-of-marketing"
            >
              <b-button class="button-white-transparen"><b>Explore All Speakers</b></b-button>
            </a>
          </b-col>
        </b-row>
      </b-col>
    </b-row>

  </b-container>




</template>

<style scoped lang="sass">
@import @/sass/screens/home/header.sass
</style>

<script>


export default {
  name: 'Header',
}
</script>
